export class InvalidChildrenError extends Error {
  constructor(message?: string) {
    super(message) // 'Error' breaks prototype chain here
    this.name = `InvalidChildrenError`
    Object.setPrototypeOf(this, new.target.prototype) // restore prototype chain
  }
}
